var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1667 21.4494C21.8303 23.9135 19.7324 25.8333 17.1693 25.8333C14.3787 25.8333 12.1027 23.5573 12.1027 20.7666C12.1027 18.3323 13.8245 16.3036 16.1006 15.8187C15.8235 15.0369 15.6949 14.1958 15.6553 13.3151C12.1818 14.0276 9.56934 17.0953 9.56934 20.7666C9.56934 24.9526 12.9834 28.3666 17.1693 28.3666C20.9594 28.3666 24.0964 25.5661 24.6506 21.9145C23.7995 21.8651 22.9683 21.7067 22.1667 21.4494Z",
    fill: "#00A3FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2901 22.0234L29.7469 22.0135C29.6578 22.8547 29.5292 23.6859 29.2719 24.4875L29.0245 25.2792L31.0828 27.0505L29.5688 29.6828L26.9958 28.7724L26.4219 29.376C24.6901 31.2463 22.4635 32.5328 19.9896 33.0969L19.188 33.2849L18.6833 35.9667H15.6453L15.1505 33.2849L14.3391 33.1068C11.8651 32.5328 9.63854 31.2562 7.90677 29.3859L7.34271 28.7724L4.76979 29.6828L3.24583 27.0505L5.30417 25.2891L5.06667 24.4875C4.69063 23.2802 4.5026 22.0333 4.5026 20.7667C4.5026 19.5099 4.69063 18.2531 5.05677 17.0359L5.30417 16.2542L3.24583 14.4828L4.7599 11.8505L7.34271 12.7609L7.90677 12.1474C9.64844 10.2771 11.8651 9.00051 14.3391 8.42655L15.1505 8.24843L15.6453 5.56666H16.5063L16.8526 3.03333H13.5375L12.9635 6.1703C10.5885 6.85312 8.43125 8.10989 6.6401 9.82187L3.62188 8.76301L0 15.037L2.41458 17.1052C2.11771 18.3026 1.96927 19.5297 1.96927 20.7667C1.96927 22.0036 2.11771 23.2307 2.41458 24.4281L0 26.4963L3.62188 32.7703L6.6401 31.7115C8.43125 33.4333 10.5885 34.6802 12.9635 35.363L13.5375 38.5H20.7911L21.375 35.363C23.75 34.6802 25.9073 33.4333 27.6885 31.7115L30.7068 32.7703L34.3286 26.4963L31.9141 24.4281C32.112 23.6463 32.2208 22.8349 32.2901 22.0234Z",
    fill: "#00A3FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6357 10.6333C33.6357 14.1265 30.7956 16.9666 27.3023 16.9666C23.8091 16.9666 20.969 14.1265 20.969 10.6333C20.969 7.14003 23.8091 4.29993 27.3023 4.29993C30.7956 4.29993 33.6357 7.14003 33.6357 10.6333Z",
    stroke: "#00A3FA",
    strokeWidth: 2.422222
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1692 10.6334H20.6723",
    stroke: "#00A3FA",
    strokeWidth: 2.422222
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7646 10.6334H37.436",
    stroke: "#00A3FA",
    strokeWidth: 2.422222
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3027 0.5V4.09219",
    stroke: "#00A3FA",
    strokeWidth: 2.422222
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3027 17.1744V20.7666",
    stroke: "#00A3FA",
    strokeWidth: 2.422222
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1379 3.46875L22.6119 5.94271",
    stroke: "#00A3FA",
    strokeWidth: 2.422222
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8645 15.1954L34.4671 17.798",
    stroke: "#00A3FA",
    strokeWidth: 2.422222
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4675 3.46875L31.9243 6.01198",
    stroke: "#00A3FA",
    strokeWidth: 2.422222
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6812 15.2546L20.1379 17.7979",
    stroke: "#00A3FA",
    strokeWidth: 2.422222
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiIcon);
export default __webpack_public_path__ + "static/media/api-icon.72af74d505aa2584db7e8673ad5972c7.svg";
export { ForwardRef as ReactComponent };